import { DialogContentText } from '@mui/material';
import { Component } from 'react';
import { PhoneNumberModel } from '../../models/phone-number.model';
import { PlanModel, TierOccurrence } from '../../models/plans.model';
import { PlanHistoryModel, RechargeStatus } from '../../models/transaction-history.model';
import { UtilityService } from '../../services/UtilityService';
import { appNote, RechargeStatusLabels } from './constants';

interface Props {
	currentPlan?: PlanModel;
	currentPhoneNumber?: PhoneNumberModel;
	CurrentAddons?: PlanModel[];
	transactionHistory?: PlanHistoryModel;
	IsMobileDevice?: boolean
}

interface State {

}
export default class PlanDetails extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}
	render() {
		const plan = this.props.currentPlan
		const PlanDates = this.props.currentPhoneNumber?.Plans.find((x: PlanHistoryModel) => x.PlanID === plan?.PlanID)
		return (
			<>
				{plan !== undefined &&
					<>
						{(this.props.transactionHistory?.PlanType !== 2 || !this.props.transactionHistory) ?
							<DialogContentText className={`${this.props.IsMobileDevice ? 'settings-paper-border mx-2' : 'b-around-text-field-border-4'} br-0_2 p-3`} id="alert-dialog-description">
								<div className='d-flex flex-direction justify-between'>
									<div className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-header-title-font`}>{plan.Name}</div>
									<div className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary pb-2`}>{!!PlanDates && PlanDates.IsYearPlan ? plan.YearlyPrice : plan.Price !== 0 ? `$${plan.Price}` : appNote.FREE}/Month</div>

									<div className='d-flex justify-between'>
										<div className='d-flex flex-direction justify-between'>
											<span className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary pb-1`}>Features</span>
											{plan.Features.filter(x => x.Type === 0).map(x => <span className={`${this.props.IsMobileDevice ? 'h4' : 'h5-regular'} color-plans-details-text`}>{x.Label}</span>)}
											<span className={`${this.props.IsMobileDevice ? ' h3 pt-3 pb-1' : 'h3-bold pt-1'} color-primary `}>Additional Features</span>
											{plan.Features.filter(x => x.Type === 1).map(x => <span className={`${this.props.IsMobileDevice ? 'h4' : 'h5-regular'} color-plans-details-text`}>{x.Label}</span>)}
											{plan.Features.filter(x => x.Type === 2).map(x => <>
												{x.Label !== '' && <><span className={`${this.props.IsMobileDevice ? ' h3 pt-3 pb-1' : 'h3-bold py-1'} color-primary `}>Additional Purchases</span>
													<span className={`${this.props.IsMobileDevice ? 'h4' : 'h5-regular'} color-plans-details-text`}>{x.Label}</span></>}</>)}
											{this.props.IsMobileDevice && <>
												{!!this.props.transactionHistory &&
													<div className={`${this.props.IsMobileDevice ? "mt-3" : ""}`}>
														<span className={`h3 pt-3 color-primary pb-1`}>Status</span>
														<div className={`${this.props.transactionHistory.StatusType === 1 || this.props.transactionHistory.StatusType === 3 ? "color-primary-success" : this.props.transactionHistory.StatusType === 2 || this.props.transactionHistory.StatusType === 4 ? 'color-primary-warning' : 'color-primary-danger'} pb-2`}> {this.props.transactionHistory.StatusType === 1 ? RechargeStatusLabels.ONGOING : this.props.transactionHistory.StatusType === 2 ? RechargeStatusLabels.UPCOMING : this.props.transactionHistory.StatusType === 3 ? RechargeStatusLabels.COMPLETED : this.props.transactionHistory.StatusType === 4 ? RechargeStatusLabels.ON_HOLD : this.props.transactionHistory.StatusType === 5 ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE}</div>
													</div>
												}
												<span className={`h3 pt-3 color-primary`}>Validity</span>
												<span className={`h4`}>Start Date</span>
												<span className={`br-0_2 color-vigenary-light h4`}>
													{this.props.transactionHistory ? this.props.transactionHistory.StartDate : UtilityService.convertDateToDay(PlanDates?.StartDate)}
												</span>
												<span className={`pt-1 h4`}>End Date</span>
												<span className={`br-0_2 color-vigenary-light h4`}>
													{this.props.transactionHistory ? this.props.transactionHistory.EndDate : UtilityService.convertDateToDay(PlanDates?.EndDate)}
												</span>
											</>}
										</div>
										<div className='d-flex flex-direction'>
											{!!this.props.transactionHistory && !this.props.IsMobileDevice &&
												<div className='d-flex flex-direction'>
													<span className={`${this.props.IsMobileDevice ? 'h3 ' : 'h3-bold'} color-primary pb-1`}>Status</span>
													<span className={`${this.props.transactionHistory.StatusType === 1 || this.props.transactionHistory.StatusType === 3 ? "color-primary-success" : this.props.transactionHistory.StatusType === 2 || this.props.transactionHistory.StatusType === 4 ? 'color-primary-warning' : 'color-primary-danger'} pb-2`}> {this.props.transactionHistory.StatusType === 1 ? RechargeStatusLabels.ONGOING : this.props.transactionHistory.StatusType === 2 ? RechargeStatusLabels.UPCOMING : this.props.transactionHistory.StatusType === 3 ? RechargeStatusLabels.COMPLETED : this.props.transactionHistory.StatusType === 4 ? RechargeStatusLabels.ON_HOLD : this.props.transactionHistory.StatusType === 5 ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE}</span>
												</div>
											}
											{!this.props.IsMobileDevice && <div className='d-flex flex-direction mt-5'>
												<span className='h3-bold color-primary pb-1'>Validity</span>
												<span className='h5-regular'>Start Date</span>
												<span className='br-0_2 color-vigenary-light h4-regular'>
													{this.props.transactionHistory ? this.props.transactionHistory.StartDate : UtilityService.convertDateToDay(PlanDates?.StartDate)}
												</span>
												<span className='pt-1 h5-regular'>End Date</span>
												<span className='br-0_2 color-vigenary-light h4-regular'>
													{this.props.transactionHistory ? this.props.transactionHistory.EndDate : UtilityService.convertDateToDay(PlanDates?.EndDate)}
												</span>
											</div>}
										</div>
									</div>
								</div>
							</DialogContentText> :
							<DialogContentText className={`${this.props.IsMobileDevice ? 'mx-2' : ''} b-around-text-field-border-4 br-0_2 p-3 h5-regular`} >
								<div className='d-flex flex-direction justify-between py-1'>
									<div className={`d-flex justify-between ${this.props.IsMobileDevice ? "flex-direction" : ""}`}>
										<div>
											<div className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'}  color-primary`}>{plan.Name}</div>
											<div className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary pb-2`}>${plan.Price}</div>
										</div>
										{!!this.props.transactionHistory &&
											<div className='d-flex flex-direction'>
												<span className={`${this.props.IsMobileDevice ? 'h3 pt-2' : 'h3-bold pb-1'} color-primary`}>Status</span>
												<span className={`${this.props.transactionHistory.StatusType === 1 || this.props.transactionHistory.StatusType === 3 ? "color-primary-success" : this.props.transactionHistory.StatusType === 2 || this.props.transactionHistory.StatusType === 4 ? 'color-primary-warning' : 'color-primary-danger'} pb-1`}> {this.props.transactionHistory.StatusType === 1 ? RechargeStatusLabels.ONGOING : this.props.transactionHistory.StatusType === 2 ? RechargeStatusLabels.UPCOMING : this.props.transactionHistory.StatusType === 3 ? RechargeStatusLabels.COMPLETED : this.props.transactionHistory.StatusType === 4 ? RechargeStatusLabels.ON_HOLD : this.props.transactionHistory.StatusType === 5 ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE}</span>
											</div>
										}
									</div>
									<div className={this.props.IsMobileDevice ? "" : 'd-flex justify-between'}>
										<div className='d-flex flex-direction'>
											<span className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary`}>Features</span>
											<span>{plan.Features.filter(x => x.Type === 0).map(x => <span className={`${this.props.IsMobileDevice ? 'h4' : 'h5-regular'} color-plans-details-text`}>{x.Label}</span>)}</span>
										</div>
										<div className="d-flex flex-direction">
											<span className={`${this.props.IsMobileDevice ? 'h3 ' : 'h3-bold pb-1'} color-primary `}>Validity</span>
											<span className='color-primary-success'>{plan.Features.map(y => y.Validity === -1 ? "Unlimited" : y.Validity)}</span>
										</div>
									</div>
								</div>
							</DialogContentText>
						}
					</>
				}
				<DialogContentText className={`${!!this.props.CurrentAddons && 'b-around-text-field-border-4 br-0_2 p-3  h5-regular'} ${this.props.IsMobileDevice && 'mx-2'}`} id="alert-dialog-description">
					{this.props.CurrentAddons?.map(x =>
						<div className='d-flex flex-direction justify-between py-1'>
							<div className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary`}>{x.Name}<span className='pl-2 color-vigenary-light'>x{UtilityService.maskSingleDigitWithZero(this.props.currentPhoneNumber?.Plans.filter(y => y.PlanID === x.PlanID && y.StatusType === RechargeStatus.ONGOING).length)}</span></div>
							<div className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary pb-2`}>${x.Price}</div>

							<div className='d-flex justify-between'>
								<div className='d-flex flex-direction justify-between'>
									<span className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary`}>Features</span>
									<span className={`${this.props.IsMobileDevice ? 'h4' : 'h5-regular'} color-plans-details-text`}>{x.Features.map(y => y.Label)}</span>
								</div>
								<div className='d-flex flex-direction'>
									<span className={`${this.props.IsMobileDevice ? 'h3' : 'h3-bold'} color-primary pb-1`}>Validity</span>
									<span className='color-primary-success'>{x.TierOccurrence === TierOccurrence.RECURRING ? x.Features.map(y => y.Validity === -1 ? this.props.transactionHistory ? this.props.transactionHistory.EndDate : UtilityService.convertDateToDay(PlanDates?.EndDate) : y.Validity) : x.Features.map(y => y.Validity === -1 ? "Unlimited" : y.Validity)}</span>
								</div>
							</div>
						</div>
					)}
				</DialogContentText>
			</>
		);
	}
}